const SamoaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112244)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C6.86953 13.1305 12.6956 7.30438 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#D80027"
      />
      <path d="M20 20C20 8.95437 20 7.65219 20 0C8.95437 0 0 8.95437 0 20H20Z" fill="#0052B4" />
      <path
        d="M16.0199 13.043L16.3438 14.0395H17.3914L16.5438 14.6552L16.8676 15.6516L16.0199 15.0358L15.1723 15.6516L15.4961 14.6552L14.6484 14.0395H15.6961L16.0199 13.043Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.7579 5.2168L11.2976 6.87766H13.0438L11.631 7.90383L12.1708 9.56461L10.7579 8.53813L9.34521 9.56461L9.8849 7.90383L8.47217 6.87766H10.2183L10.7579 5.2168Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.9752 6.95703L16.5148 8.61797H18.261L16.8483 9.64414L17.3879 11.3049L15.9752 10.2784L14.5625 11.3049L15.1022 9.64414L13.6895 8.61797H15.4355L15.9752 6.95703Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.8507 13.9131L12.3904 15.5739H14.1365L12.7238 16.6001L13.2635 18.2609L11.8507 17.2345L10.438 18.2609L10.9777 16.6001L9.56494 15.5739H11.3111L11.8507 13.9131Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.27936 9.56543L7.81904 11.2263H9.56521L8.1524 12.2525L8.69209 13.9132L7.27936 12.8868L5.8667 13.9132L6.40631 12.2525L4.99365 11.2263H6.73975L7.27936 9.56543Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112244">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SamoaSvg;
